'use strict';

var Autocomplete = require('./Autocomplete.js');
var Option = require('./Option.js');

const Address = {
    Autocomplete: Autocomplete.AddressAutocomplete,
    Option: Option.AddressOption,
};

exports.Address = Address;
//# sourceMappingURL=index.js.map
